import React from "react";
import PropTypes from "prop-types";
import { Box, Grid, Typography } from "@mui/material";
import { FinancingCard, getFinancingHeadingSx } from "../FinancingPresentation";
import {
  getFordCreditAppStatus,
  getEsignStatus,
  getContractStatus,
  displayAlternativeLending,
} from "../../../shared/rules/FinancingRules";

const CreditApplicationTable = ({
  orderId,
  paymentType,
  isLincolnBrand = false,
  t,
}) => {
  const getCreditAppDetails = (currentOrderId, currentPaymentType) => {
    if (currentPaymentType === "Ford Credit Financing") {
      return {
        creditApp: {
          heading: "Credit application submitted",
          content: "Yes",
        },
        applicationStatus: {
          heading: "Credit application status",
          content: getFordCreditAppStatus(currentOrderId),
        },
        eSign: {
          heading: "eSign Requested",
          content: getEsignStatus(currentOrderId),
        },
        contractStatus: {
          heading: "Contract Signed",
          content: getContractStatus(currentOrderId),
        },
        lendingOptions: {
          heading: "More lending options consent",
          content: displayAlternativeLending(currentOrderId),
        },
      };
    }

    return {};
  };

  const creditAppDetails = getCreditAppDetails(orderId, paymentType);

  return (
    <>
      <Box
        gridColumn={{
          xs: "span 12",
        }}
        sx={{ mt: 2 }}
      >
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography variant="h3" sx={getFinancingHeadingSx(isLincolnBrand)}>
              {paymentType === "Ford Credit Financing"
                ? isLincolnBrand
                  ? "Lincoln Credit Application"
                  : t
                    ? t("financing.applicationHeading")
                    : "Ford Credit Application"
                : "Credit Application"}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box
        gridColumn={{
          xs: "span 12",
        }}
      >
        <FinancingCard
          data={creditAppDetails}
          isLincolnBrand={isLincolnBrand}
        />
      </Box>
    </>
  );
};

CreditApplicationTable.propTypes = {
  isLincolnBrand: PropTypes.bool,
  orderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  paymentType: PropTypes.string.isRequired,
  t: PropTypes.func,
};

export default CreditApplicationTable;
